<template>
  <div>
    <div class="navtit">
      {{ $t('home.nav2') }}
    </div>
    <div class="banner">
      <img src="../assets/22.png" alt="">
    </div>
    <div class="container">
      <el-row :gutter="50" style="width: 800px;margin:0 auto;">
        <el-col :span="8">
          <div :class="['descript-item', index == '1' ? 'active' : '']" @click="getTabs('1')">
            <div class="descript-item-top">{{ $t('item2.tit1') }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div :class="['descript-item', index == '2' ? 'active' : '']" @click="getTabs('2')">
            <div class="descript-item-top">{{ $t('item2.tit2') }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div :class="['descript-item', index == '3' ? 'active' : '']" @click="getTabs('3')">
            <div class="descript-item-top">{{ $t('item2.tit3') }}</div>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <!-- 招股文件 -->
      <div class="file-con" v-if="index == '1'">
        <el-row :gutter="50">
          <el-col :span="12" v-for="(item, index) in zhaoGuList" :key="index">
            <div class="notice-item">
              <a :href="item.FilePath" target="_blank">
                <div class="notice-item-left">
                  <div class="notice-desc">{{ item.Title }}</div>
                  <div class="notice-desc1">{{ item.CerTime }}</div>
                </div>
                <div class="notice-item-right"></div>
              </a>
            </div>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
      </div>
      <!-- 公告通函 -->
      <div v-if="index == '2'">
        <div class="toolbar">
          <div class="pickerBox">
            <el-date-picker v-model="value" type="daterange" value-format="yyyy-MM-dd" align="right" unlink-panels
              range-separator="-" :start-placeholder="$t('item2.strDate')" :end-placeholder="$t('item2.endDate')"
              @change="picChange">
            </el-date-picker>
          </div>
          <div class="inputBox">
            <el-input v-model="input" :placeholder="$t('item2.input')" clearable @clear="getList()"></el-input>
          </div>
          <div class="search" @click="getList()">
            <img src="../assets/search.png">
          </div>
        </div>
        <div class="notice-total">
          {{ $t('item2.all') }}: <span style="color:#409EFF;">{{ tonghanList.length }}</span> {{ $t('item2.txt') }}
        </div>
        <el-divider></el-divider>
        <div class="item" v-for="item, index in tonghanList" :key="index" v-show="tonghanList.length > 0">
          <a :href="item.FilePath" target="_blank">
            <div class="date">
              <div class="hd">{{ getDate1(item.CerTime) }}</div>
              <div class="fd">{{ getDate(item.CerTime) }}</div>
            </div>
            <!-- <div class="text-main">月报表 </div> -->
            <div class="txt">{{ item.Title }}</div>
            <div class="more"></div>
          </a>
        </div>
        <!-- <div class="Pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="10"
              @current-change="getList()"
              :total="tonghanList.length">
            </el-pagination>
          </div> -->
      </div>
      <!-- 业绩报告 -->
      <div class="toolbar" v-if="index == '3'">
        <!-- <div class="inputBox"> -->
          <!-- <el-input v-model="input" :placeholder="$t('item2.input')" clearable @clear="getList()"></el-input> -->
          <!-- <el-select v-model="selected" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <div class="search" @click="getList()">
            <img src="../assets/search.png">
          </div> -->
        <!-- </div> -->

        <div class="pickerBox">
            <el-date-picker v-model="value" type="daterange" value-format="yyyy-MM-dd" align="right" unlink-panels
              range-separator="-" :start-placeholder="$t('item2.strDate')" :end-placeholder="$t('item2.endDate')"
              @change="picChange">
            </el-date-picker>
          </div>
          <div class="inputBox">
            <el-input v-model="input" :placeholder="$t('item2.input')" clearable @clear="getList()"></el-input>
          </div>
          <div class="search" @click="getList()">
            <img src="../assets/search.png">
          </div>
      </div>
      <div class="yeji" v-if="index == '3'">

        <div class="yejiItem" v-for="item, index in yejiList" :key="index">
          <a :href="item.FilePath" target="_blank">
            <img :src="item.ImgPath" alt="">
            <p class="yejiTit">{{ item.Title }}</p>
            <p class="yejiTxt">{{ item.CerTime }}</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      index: '1',
      value: '',
      input: '',
      zhaoGuList: [],
      tonghanList: [],
      yejiList: [],
      startDate: '',
      endDate: '',
      options: [{
          value: 2022,
          label: 2022
        }, {
          value: 2023,
          label: 2023
        }, {
          value: 2024,
          label: 2024
        }, {
          value: 2025,
          label: 2025
        }],selected: 2025  
    }
  },
  watch: {
    '$i18n.locale': function (newVal, oldVal) {
      console.log(newVal, oldVal)
      this.getList()
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    picChange(e) {
      console.log(e)
      if (e === null) {
        this.startDate = ''
        this.endDate = ''
      } else {
        this.startDate = e[0]
        this.endDate = e[1]
      }
      this.getList()
    },
    getDate(str) {
      return str.split('-')[0] + '-' + str.split('-')[1]
    },
    getDate1(str) {
      return str.split('-')[2]
    },
    getTabs(e) {
      this.index = e
      this.getList()
    },
    getList() {
      const that = this
      let url = ''
      let t = ''
      // eslint-disable-next-line eqeqeq
      if (localStorage.getItem('locale') === 'en') {
        url = '/Front_Index/Main/GetDataEn'
      } else if (localStorage.getItem('locale') === 'cn') {
        url = '/Front_Index/Main/GetData'
        t = 0
      } else if (localStorage.getItem('locale') === 'mo') {
        url = '/Front_Index/Main/GetData'
        t = 1
      }
      const obj = {
        type: that.index === '1' ? 1 : (that.index === '2' ? 3 : (that.index === '3' ? 2 : '')),
        t: t,
        s: that.startDate,
        e: that.endDate,
        sh: that.input,
        year:0
      }
      // if(obj.type===2){
      //   obj.year=that.selected;
      // }
      console.log(obj);
      this.$axios.post(url, obj).then(response => {
        console.log(response)
        if (that.index === '1') {
          that.zhaoGuList = response.data
        }
        if (that.index === '2') {
          that.tonghanList = response.data
        }
        if (that.index === '3') {
          that.yejiList = response.data
        }
      })
    }
  }
}
</script>
<style scoped>
.el-divider--horizontal {
  margin: 0;
}

a {
  text-decoration: none;
  color: inherit;
}

.navtit {
  font-size: 36px;
  color: #000000;
  line-height: 45px;
  text-align: center;
  padding: 30px 60px;
}

.banner {
  width: 100%;
  height: 540px;
  margin: 0 auto;
  overflow: hidden;
}

.banner img {
  width: 100%;
  height: 100%;
}

.container {
  width: 1050px;
  margin: 0 auto;
  padding: 80px 0;
}

.descript-item {
  background-color: #f7f7f7;
  width: 100%;
  height: 40px;
  /* border-radius: 5px; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  font-size: 18px;
  color: #409EFF;
  line-height: 45px;
}

.descript-item:hover {
  background-color: #409EFF;
  color: white;
}

.active {
  background-color: #409EFF;
  color: white;
}

.file-con {
  margin-top: 50px;
}

.notice-item {
  height: 100px;
  margin-bottom: 20px;
}

.notice-item a:hover {
  background-color: #409EFF;
  color: white;
}

.notice-item a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f7f7;
  color: #898888;
  border-radius: 5px;
  padding: 20px;
  text-decoration: none;
}

.notice-item-left {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.notice-desc {
  width: 400px;
  font-size: 18px;
  line-height: 24px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notice-desc1 {
  font-size: 14px;
  color: #898888;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.notice-item a:hover .notice-desc1 {
  color: white;
}

.notice-item-right {
  width: 40px;
  height: 40px;
  background-image: url(../assets/pdf.png);
  background-position: center 0;
  background-repeat: no-repeat;
  background-size: 40px 40px;
}

.notice-item a:hover .notice-item-right {
  background-image: url(../assets/pdf1.png);
}

.toolbar {
  padding: 15px;
  background: #f3f3f3;
  color: #646464;
  position: relative;
  z-index: 1;
  margin-top: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

}

.pickerBox {
  width: 35%;
}

.inputBox {
  width: 59%;
  margin-left: 15px;
}

.search {
  width: 40px;
  height: 40px;
  margin-left: 15px;
  background: #409EFF;
}

.search img {
  width: 20px;
  height: 20px;
  margin: 10px;
}

.notice-total {
  margin: 20px 0 10px;
  color: #919191;
  text-align: left;
}

.item {
  width: 100%;
  height: 100px;
  position: relative;
  border-bottom: 1px solid #DCDFE6;
  cursor: pointer;
  text-align: left;
}

.item:hover {
  background-color: #409EFF;
}

.item a {
  display: inline-block;
  height: 100%;
  width: 100%;
}

.date {
  width: 60px;
  height: 56px;
  position: absolute;
  left: 22px;
  top: 22px;
  color: #898888;
  text-align: center;
}

.item:hover .date {
  color: white;
}

.date::before {
  position: absolute;
  top: 50%;
  right: -22px;
  transform: translateY(-50%);
  content: '';
  display: block;
  width: 1px;
  height: 48px;
  background: #e4e4e4;
}

.hd {
  width: 60px;
  height: 40px;
  line-height: 1;
  font-size: 40px;
  color: #898888;
}

.item:hover .hd {
  color: white;
}

.item:hover .fd {
  color: white;
}

.item:hover .txt {
  color: white;
}

.fd {
  width: 60px;
  height: 16px;
  line-height: 1;
  font-size: 16px;
  color: #898888;
}

.text-main {
  position: absolute;
  top: 30px;
  left: 120px;
  color: #409EFF;
}

.txt {
  position: absolute;
  top: 42px;
  left: 126px;
  color: #898888;
}

.more {
  width: 40px;
  height: 40px;
  background-image: url(../assets/pdf.png);
  background-position: center 0;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  position: absolute;
  top: 30px;
  right: 30px;
}

.item:hover .more {
  background-image: url(../assets/pdf1.png);
}

.Pagination {
  width: 100%;
  text-align: right;
  padding-top: 15px;
  position: relative;
}

.yeji {
  margin-top: 50px;
  width: 100%;
  display: flex;
  flex-wrap: wrap; /* 添加换行属性 */
  justify-content: flex-start; /* 改为左对齐 */
  gap: 20px; /* 添加项目间距 */
}

.yejiItem {
  width: calc((100% - 40px) / 3); /* 计算宽度，考虑间距 */
  height: auto;
  cursor: pointer;
  color: #000000;
  margin-bottom: 20px; /* 添加底部间距 */
}

.yeji img {
  width: 214px; /* 改为百分比宽度 */
  height: 300px;
  border: 1px solid #F7F7F7;
  object-fit: cover; /* 保持图片比例 */
}

.yejiTit {
  /* text-align: left; */
  margin-top: 10px;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
  width: 66%;
  margin-left: 17%;
}

.yejiTxt {
  margin-top: 10px;
  text-align: left;
  font-size: 14px;
  color: #898888;
  width:24%;
  margin-left:39%;
}

/* 响应式设计 - 可选 */
@media (max-width: 900px) {
  .yejiItem {
    width: calc((100% - 20px) / 2); /* 在小屏幕上每行显示2个 */
  }
}

@media (max-width: 600px) {
  .yejiItem {
    width: 100%; /* 在超小屏幕上每行显示1个 */
  }
}
</style>
